// Справочник по API: https://www.wix.com/velo/reference/api-overview/introduction
// Пример «Hello, World!»: https://learn-code.wix.com/en/article/1-hello-world

$w.onReady(function () {


});

/**
*	Adds an event handler that runs when the element is clicked.
	[Read more](https://www.wix.com/corvid/reference/$w.ClickableMixin.html#onClick)
*	 @param {$w.MouseEvent} event
*/
export function button16_click(event) {
	$w("#button16").hide();
	$w("#button17").show();
	$w("#text58").expand();

	$w("#text60").collapse();
	$w("#text62").collapse();
	$w("#text64").collapse();

	$w("#button18").hide();
	$w("#button20").hide();
	$w("#button22").hide();

	$w("#button21").show();
	$w("#button23").show();
	$w("#button19").show();
	// This function was added from the Properties & Events panel. To learn more, visit http://wix.to/UcBnC-4
	// Add your code for this event here: 
}

/**
*	Adds an event handler that runs when the element is clicked.
	[Read more](https://www.wix.com/corvid/reference/$w.ClickableMixin.html#onClick)
*	 @param {$w.MouseEvent} event
*/
export function button17_click(event) {
	$w("#button16").show();
	$w("#button17").hide();
	$w("#text58").collapse();
	// This function was added from the Properties & Events panel. To learn more, visit http://wix.to/UcBnC-4
	// Add your code for this event here: 
}

/**
*	Adds an event handler that runs when the element is clicked.
	[Read more](https://www.wix.com/corvid/reference/$w.ClickableMixin.html#onClick)
*	 @param {$w.MouseEvent} event
*/
export function button19_click(event) {
	$w("#button19").hide();
	$w("#button18").show();
	$w("#text60").expand();

	$w("#text58").collapse();
	$w("#text62").collapse();
	$w("#text64").collapse();

	$w("#button17").hide();
	$w("#button20").hide();
	$w("#button22").hide();

	$w("#button16").show();
	$w("#button23").show();
	$w("#button21").show();
	// This function was added from the Properties & Events panel. To learn more, visit http://wix.to/UcBnC-4
	// Add your code for this event here: 
}

/**
*	Adds an event handler that runs when the element is clicked.
	[Read more](https://www.wix.com/corvid/reference/$w.ClickableMixin.html#onClick)
*	 @param {$w.MouseEvent} event
*/
export function button18_click(event) {
	$w("#button19").show();
	$w("#button18").hide();
	$w("#text60").collapse();
	// This function was added from the Properties & Events panel. To learn more, visit http://wix.to/UcBnC-4
	// Add your code for this event here: 
}

/**
*	Adds an event handler that runs when the element is clicked.
	[Read more](https://www.wix.com/corvid/reference/$w.ClickableMixin.html#onClick)
*	 @param {$w.MouseEvent} event
*/
export function button21_click(event) {
	$w("#button21").hide();
	$w("#button20").show();
	$w("#text62").expand();

	$w("#text58").collapse();
	$w("#text60").collapse();
	$w("#text64").collapse();

	$w("#button17").hide();
	$w("#button18").hide();
	$w("#button22").hide();

	$w("#button16").show();
	$w("#button23").show();
	$w("#button18").show();
	// This function was added from the Properties & Events panel. To learn more, visit http://wix.to/UcBnC-4
	// Add your code for this event here: 
}

/**
*	Adds an event handler that runs when the element is clicked.
	[Read more](https://www.wix.com/corvid/reference/$w.ClickableMixin.html#onClick)
*	 @param {$w.MouseEvent} event
*/
export function button20_click(event) {
	$w("#button21").show();
	$w("#button20").hide();
	$w("#text62").collapse();
	// This function was added from the Properties & Events panel. To learn more, visit http://wix.to/UcBnC-4
	// Add your code for this event here: 
}


/**
*	Adds an event handler that runs when the element is clicked.
	[Read more](https://www.wix.com/corvid/reference/$w.ClickableMixin.html#onClick)
*	 @param {$w.MouseEvent} event
*/
export function button23_click(event) {
	$w("#button23").hide();
	$w("#button22").show();

	$w("#text64").expand();
	$w("#text58").collapse();
	$w("#text60").collapse();
	$w("#text62").collapse();

	$w("#button17").hide();
	$w("#button18").hide();
	$w("#button20").hide();

	$w("#button16").show();
	$w("#button21").show();
	$w("#button19").show();
	// This function was added from the Properties & Events panel. To learn more, visit http://wix.to/UcBnC-4
	// Add your code for this event here: 
}

/**
*	Adds an event handler that runs when the element is clicked.
	[Read more](https://www.wix.com/corvid/reference/$w.ClickableMixin.html#onClick)
*	 @param {$w.MouseEvent} event
*/
export function button22_click(event) {
	$w("#button23").show();
	$w("#button22").hide();
	$w("#text64").collapse();
	// This function was added from the Properties & Events panel. To learn more, visit http://wix.to/UcBnC-4
	// Add your code for this event here: 
}